export default "__VITE_ASSET__a74823a8__"